import Layout from "components/Layout";
import React from "react";
import ItemSettingAddForm from "./components/ItemSettingAddForm";

function ItemSettingAddPage() {
  return (
    <Layout title="SMS 항목 등록">
      <ItemSettingAddForm />
    </Layout>
  );
}

export default ItemSettingAddPage;
